export const cashierSettingsValidationRules = {
  country: { required: true, message: 'Please choose country', trigger: ['blur', 'change'] },
  commonFieldRule: { required: true, message: 'Please input amount', trigger: ['blur', 'change'] },
};
